import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root',
})
export class ActivityLogService extends BaseService {
  constructor(http: HttpClient) {
    super(http);
  }

  // Obtenir les logs d'activité de l'utilisateur connecté avec pagination
  getMyActivityLogs(page: number = 1, limit: number = 10): Observable<any> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('limit', limit.toString());

    return this.http.get(`${this.baseUrl}/activity-logs`, {
      headers: this.getAuthHeaders(),
      params: params,
    });
  }
}
